import React, { useEffect } from "react";
import Form from "./../components/Form";
const FormPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <Form />;
};

export default FormPage;
